import Component from '@galactic-advisors/component-loader';
import Editor from '@toast-ui/editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';

const DEFAULTS = {
  hiddenInputSelector: '[data-comp-editor-hid]',
  editorSelector: '[data-comp-editor]',
};

export default class MarkdownEditor extends Component {
  static selector = '[data-comp-markdown-editor]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.hiddenInput = this.$container.querySelector(
      this.$options.hiddenInputSelector,
    );

    this.editorEl = this.$container.querySelector(this.$options.editorSelector);

    this.editorConfig = JSON.parse(this.$container.dataset.compEditorConfig);

    this.init();
  }

  init() {
    this.editor = new Editor({
      el: this.editorEl,
      height: this.editorConfig.height ?? '300px',
      initialEditType: 'wysiwyg',
      initialValue: this.hiddenInput.value ?? null,
      placeholder: this.editorConfig.placeholder ?? '',
      toolbarItems: [
        ['bold', 'italic', 'strike'],
        ['outdent', 'indent'],
        ['ul', 'ol'],
        ['link'],
      ],
      usageStatistics: false,
      theme: this.editorConfig.theme,
    });

    this.editor.on('blur', () => {
      this.hiddenInput.value = this.editor.getMarkdown();
    });
  }
}
